import {
  LoaderOverlayLayer,
  LoaderRoot,
  LoaderStatus,
  VisuallyHidden,
} from 'ui/loader/loader.styles';
import type { LoaderProps } from 'ui/loader/loader.types';
import { Spinner } from 'ui/spinner';

const LOADING_LABEL = 'Loading';

const Loader = ({
  loading,
  fullScreen = true,
  backdrop = 'gray',
  overlay = 'gray',
  sx,
}: LoaderProps) =>
  loading ? (
    <LoaderRoot
      fullScreen={fullScreen}
      backdrop={backdrop}
      sx={sx}
      data-testid="loader"
    >
      <LoaderOverlayLayer overlay={overlay} />
      <LoaderStatus role="status">
        <Spinner size="xlarge" label={LOADING_LABEL} aria-hidden />
        <VisuallyHidden>{LOADING_LABEL}</VisuallyHidden>
      </LoaderStatus>
    </LoaderRoot>
  ) : null;

export default Loader;
